import { render } from "./AskusList.vue?vue&type=template&id=22cdf9bb&scoped=true"
import script from "./AskusList.vue?vue&type=script&lang=js"
export * from "./AskusList.vue?vue&type=script&lang=js"

import "./AskusList.vue?vue&type=style&index=0&id=22cdf9bb&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cdf9bb"]])

export default __exports__